/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Configuration } from '../models/Configuration';
import type { InfoMessageList } from '../models/InfoMessageList';
import type { MessProject } from '../models/MessProject';
import type { MessProjectCreate } from '../models/MessProjectCreate';
import type { MessProjectUpdate } from '../models/MessProjectUpdate';
import type { Messung } from '../models/Messung';
import type { MessungCreate } from '../models/MessungCreate';
import type { MessungSaveInfo } from '../models/MessungSaveInfo';
import type { SensorBase } from '../models/SensorBase';
import type { SensorEntity } from '../models/SensorEntity';
import type { StrainMeasurement } from '../models/StrainMeasurement';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MessProjectsService {
    /**
     * Get Info Messages
     * Get info messagesabout devices for a specific MessProject
     * @param messprojectId
     * @returns InfoMessageList Successful Response
     * @throws ApiError
     */
    public static getInfoMessages(
        messprojectId: string,
    ): CancelablePromise<InfoMessageList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/info-messages/{messproject_id}/devices',
            path: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Info Messages
     * Get info messages about state for a specific MessProject
     * @param messprojectId
     * @returns InfoMessageList Successful Response
     * @throws ApiError
     */
    public static getInfoMessagesState(
        messprojectId: string,
    ): CancelablePromise<InfoMessageList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/info-messages/{messproject_id}/state',
            path: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Messproject
     * Create a new MessProjHTTPException 400: If the parent Project does not exist
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createMessprojectApiMessprojectsPost(
        requestBody: MessProjectCreate,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messprojects/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Messprojects
     * List all MessProjects
     * @param skip
     * @param limit
     * @returns MessProject Successful Response
     * @throws ApiError
     */
    public static listMessprojects(
        skip?: number,
        limit: number = 100,
    ): CancelablePromise<Array<MessProject>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/',
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Messproject
     * Get MessProject by ID
     * @param messprojectId
     * @returns MessProject Successful Response
     * @throws ApiError
     */
    public static getMessproject(
        messprojectId: string,
    ): CancelablePromise<MessProject> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/{messproject_id}',
            path: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Messproject
     * Update MessProject
     * @param messprojectId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateMessproject(
        messprojectId: string,
        requestBody: MessProjectUpdate,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/messprojects/{messproject_id}',
            path: {
                'messproject_id': messprojectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Messproject
     * Delete MessProject
     * @param messprojectId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteMessproject(
        messprojectId: string,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/messprojects/{messproject_id}',
            path: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Messprojects By Project
     * List MessProjects by Project ID
     * @param projectId
     * @returns MessProject Successful Response
     * @throws ApiError
     */
    public static listMessprojectsByProject(
        projectId: string,
    ): CancelablePromise<Array<MessProject>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/by-project/{project_id}',
            path: {
                'project_id': projectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Load Strain Measurements By Messproject
     * @param messprojectId
     * @param strainMeasurementIds
     * @returns StrainMeasurement Successful Response
     * @throws ApiError
     */
    public static getStrainMeasurementsByMessprojectId(
        messprojectId: string,
        strainMeasurementIds?: (Array<string> | null),
    ): CancelablePromise<Array<StrainMeasurement>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/{messproject_id}/strain-measurements',
            path: {
                'messproject_id': messprojectId,
            },
            query: {
                'strain_measurement_ids': strainMeasurementIds,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Load Backscatter Measurements By Messproject
     * @param messprojectId
     * @param backscatterMeasurementIds
     * @returns StrainMeasurement Successful Response
     * @throws ApiError
     */
    public static getBackscatterMeasurementsByMessprojectId(
        messprojectId: string,
        backscatterMeasurementIds?: (Array<string> | null),
    ): CancelablePromise<Array<StrainMeasurement>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/{messproject_id}/backscatter-measurements',
            path: {
                'messproject_id': messprojectId,
            },
            query: {
                'backscatter_measurement_ids': backscatterMeasurementIds,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Messproject Messungen
     * Get all Messungen for a MessProject
     * @param messprojectId
     * @returns Messung Successful Response
     * @throws ApiError
     */
    public static getMessungenByMessprojectId(
        messprojectId: string,
    ): CancelablePromise<Array<Messung>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/{messproject_id}/messungen',
            path: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Messung For Messproject
     * @param messprojectId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createMessungForMessproject(
        messprojectId: string,
        requestBody: MessungCreate,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messprojects/{messproject_id}/messungen',
            path: {
                'messproject_id': messprojectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Most Recent Configuration For Messproject
     * Get the most recent Configuration for a MessProject.
     * @param messprojectId
     * @returns Configuration Successful Response
     * @throws ApiError
     */
    public static getMostRecentConfigurationForMessprojectApiMessprojectsMessprojectIdLatestConfigurationGet(
        messprojectId: string,
    ): CancelablePromise<Configuration> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/{messproject_id}/latest-configuration',
            path: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Messproject Sensors
     * Get all Sensors associated with a MessProject via its SensorMaps
     *
     * Returns a deduplicated list of all sensors that are assigned to any SensorMap
     * associated with this MessProject. This provides a consolidated view of all
     * sensors relevant to the measurement project.
     *
     * Args:
     * messproject_id: The MessProject ID
     *
     * Returns:
     * List of unique Sensor objects from all associated SensorMaps
     * @param messprojectId
     * @param history Retrieve all Sensors including their historical version if history=true
     * @param assigned Retrieve all Sensors including their historical version if history=true
     * @param withMessung Retrieve all Sensors with a Messung if history=true and with_messung=true
     * @returns SensorEntity Successful Response
     * @throws ApiError
     */
    public static getSensorsByMessprojectId(
        messprojectId: string,
        history?: (string | null),
        assigned?: (string | null),
        withMessung?: (string | null),
    ): CancelablePromise<Array<SensorEntity>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/{messproject_id}/sensors',
            path: {
                'messproject_id': messprojectId,
            },
            query: {
                'history': history,
                'assigned': assigned,
                'with_messung': withMessung,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Sensor For Messproject
     * Create a new Sensor for a specific MessProject
     *
     * This is a convenience endpoint that automatically links the sensor to the MessProject's SensorMap.
     * The messproject_id is taken from the URL path and doesn't need to be in the request body.
     *
     * Raises:
     * HTTPException 404: If the parent MessProject does not exist
     * HTTPException 400: If there's a validation error
     * @param messprojectId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static createSensorForMessprojectApiMessprojectsMessprojectIdSensorsPost(
        messprojectId: string,
        requestBody: SensorBase,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messprojects/{messproject_id}/sensors',
            path: {
                'messproject_id': messprojectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Latest Reference Messung Ep
     * Get the most recent Messung with reference=True for a MessProject
     *
     * Returns the most recent measurement where reference=True, sorted by created_at_dttm.
     *
     * Args:
     * messproject_id: The MessProject ID
     *
     * Returns:
     * The most recent reference Messung
     *
     * Raises:
     * HTTPException 404: If the MessProject does not exist or no reference measurement found
     * @param messprojectId
     * @returns Messung Successful Response
     * @throws ApiError
     */
    public static getLatestReferenceMessungEpApiMessprojectsMessprojectIdMessungenReferenceLatestGet(
        messprojectId: string,
    ): CancelablePromise<Messung> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/{messproject_id}/messungen/reference/latest',
            path: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get References By Messproject Id
     * Get all Messungen with reference=True for a MessProject
     *
     * Returns all measurements where reference=True, sorted by created_at_dttm.
     *
     * Args:
     * messproject_id: The MessProject ID
     *
     * Returns:
     * List of reference Messungen
     *
     * Raises:
     * HTTPException 404: If the MessProject does not exist or no reference measurement found
     * @param messprojectId
     * @returns Messung Successful Response
     * @throws ApiError
     */
    public static getReferenceMessungenByMessproject(
        messprojectId: string,
    ): CancelablePromise<Array<Messung>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/messprojects/{messproject_id}/messungen/references',
            path: {
                'messproject_id': messprojectId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Messung For Messproject Save
     * @param messprojectId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static saveMessungForMessproject(
        messprojectId: string,
        requestBody: MessungSaveInfo,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/messprojects/{messproject_id}/messungsave',
            path: {
                'messproject_id': messprojectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
